import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../apiClient';
import { User } from '../users';
import { Site } from '../sites/sites';
import { DailyTempWorker } from '../dailyReports/dailyTempWorkers';

export interface TempWorker {
    crudStatus: number;
    _id: string;
    designation: string;
    codeProC: string;
    email?: string;
    usageCount?: {
        total: number;
        dailyTempWorkers: number;
    };
    displayOrder?: number;
    updatedAt?: string;
    createdAt?: string;
}

interface TempWorkersResponse {
    message: string;
    data: TempWorker[];
}

export interface GetAllTempWorkerQueries {
    active?: boolean;
    withUsage?: boolean;
}

export const getAllTempWorkers = async (queries?: GetAllTempWorkerQueries): Promise<TempWorkersResponse> => {
    try {
        const response: AxiosResponse<TempWorkersResponse> = await apiClient.get('/tempworker-types', { params: queries });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface UpdateTempWorkerBody {
    designation?: string;
    crudStatus?: number;
    codeProC?: string;
    email?: string;
    displayOrder?: number | null;
}

export interface TempWorkerResponse {
    message: string;
    data: TempWorker;
}

export const updateTempWorker = async (tempWorkerId: string, data: UpdateTempWorkerBody): Promise<TempWorkerResponse> => {
    try {
        const response: AxiosResponse<TempWorkerResponse> = await apiClient.patch('/tempworker-types/' + tempWorkerId, data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface CreateTempWorkerBody {
    designation: string;
    crudStatus?: number;
    codeProC: string;
    email?: string;
    displayOrder?: number | null;
}

export const createTempWorker = async (data: CreateTempWorkerBody): Promise<TempWorkerResponse> => {
    try {
        const response: AxiosResponse<TempWorkerResponse> = await apiClient.post('/tempworker-types', data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface MonthlyTempWorker extends TempWorker {
    dailyTempWorkersByDate: {
        date: string;
        daily: { dailyTempWorker: DailyTempWorker; user: User; site: Site }[];
    }[];
}

export interface GetMonthlyTempWorkerParams {
    date: string;
}

export interface MonthlyTempWorkersResponse {
    data: MonthlyTempWorker[];
    message: string;
}

export const getMonthlyTempWorkers = async (params: GetMonthlyTempWorkerParams): Promise<MonthlyTempWorkersResponse> => {
    try {
        const response: AxiosResponse<MonthlyTempWorkersResponse> = await apiClient.get('/tempworker-types/monthly/' + params.date);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};
